var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wh100"},[_c('OperationWorkOrder',{ref:"OperationWorkOrder",attrs:{"workOrderType":"1"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }